import { Box } from '@mui/material'; // Assuming Box is from Material-UI
import styled from 'styled-components';

import { colorTokens } from '../../../shared/components/variables';
import { ALERTS_HEADING_HEIGHT, HEADING_HEIGHT } from '../PageHeading/constants';

export const MarkerDot = styled(Box)`
  display: flex;
  height: 2rem;
  min-width: 5.2rem;
  padding: 0.5rem;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  color: ${colorTokens.primary.main};

  border-radius: 1rem;
  border: 4px solid ${colorTokens.primary.main};
  background: ${colorTokens.background.default};
`;

export const MapContainer = styled.div<{
  $hasAlertsBannner?: boolean;
}>`
  .gm-style-iw > button {
    display: none !important;
  }
  button.gm-ui-hover-effect {
    visibility: hidden;
  }
  .gm-style-iw-chr {
    max-height: 8px;
  }

  :first-child {
    height: ${({ $hasAlertsBannner }) =>
      $hasAlertsBannner
        ? `calc(100vh - ${HEADING_HEIGHT}px)`
        : `calc(100vh - ${HEADING_HEIGHT}px + ${ALERTS_HEADING_HEIGHT}px)`};
  }

  @media (max-width: 1440px) {
    :first-child {
      height: calc(100vh - ${HEADING_HEIGHT + ALERTS_HEADING_HEIGHT}px);
    }
  }

  .gm-style-mtc {
    margin-top: 0px !important;
  }

  .gm-bundled-control {
    margin-top: 60px !important;
  }
`;

export const TrafficToggleContainer = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  margin-left: 32px;
  border: 1px solid ${colorTokens.border.main};
  border-radius: 4px;
  text-decoration: none;
  background-color: #fff;
  padding: 2px 9px 2px 0;
`;
